import { render, staticRenderFns } from "./VFieldNumber.vue?vue&type=template&id=4d9396d1&"
import script from "./VFieldNumber.vue?vue&type=script&lang=js&"
export * from "./VFieldNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lucas/projects/work/autoag/autoagtruck.ch/wp-content/themes/autoag/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d9396d1')) {
      api.createRecord('4d9396d1', component.options)
    } else {
      api.reload('4d9396d1', component.options)
    }
    module.hot.accept("./VFieldNumber.vue?vue&type=template&id=4d9396d1&", function () {
      api.rerender('4d9396d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/scripts/VForm/VFieldNumber.vue"
export default component.exports